<template>
  <div class="integration-statuses">
    <IntegrationChip
      v-for="integration in integrationsList"
      :key="integration.name"
      :type="integration.name"
      :status="integration.status"
      :tooltip-text="integration.additional_info"
      :is-enabled="integration.is_enabled"
    />
  </div>
</template>

<script>
import IntegrationChip from "@/components/BusinessAddresses/IntegrationChip.vue";
import { isFeatureFlagEnabled, FEATURE_FLAG } from "@/helpers/posthog";
import { PLAN_RESTRICTIONS } from "@/enums/plan-restrictions";
import { planRestrictionsCheck } from "@/helpers/plan-restrictions-check";

export default {
  name: "IntegrationStatuses",
  components: {
    IntegrationChip
  },
  props: {
    integrations: {
      type: Object,
      required: true
    }
  },
  computed: {
    canManageLocationData() {
      return planRestrictionsCheck(PLAN_RESTRICTIONS.CAN_MANAGE_LOCATION_DATA);
    },
    integrationsList() {
      const showFacebookIntegration = isFeatureFlagEnabled(
        FEATURE_FLAG.SHOW_FACEBOOK_INTEGRATION
      );

      const showAppleIntegration = isFeatureFlagEnabled(
        FEATURE_FLAG.CN_5526_APPLE_MAPS
      );

      return Object.entries(this.integrations)
        .map(([key, value]) => ({
          name: key,
          ...value
        }))
        .filter(
          integration =>
            (this.canManageLocationData || integration.name === "google") &&
            (showFacebookIntegration || integration.name !== "facebook") &&
            (showAppleIntegration || integration.name !== "apple")
        );
    }
  }
};
</script>

<style lang="scss" scoped>
.integration-statuses {
  display: flex;
  gap: $spacing * 1.5;
}
</style>
